import { useEffect } from "react";
import { installDragScroll } from "./dragScroll";

/**
 * Monta o arraste de mouse dos carrosséis UMA vez, no nível da aplicação.
 *
 * A lógica toda vive em `dragScroll.ts`, sem React, porque o comportamento é
 * de DOM e não de componente — assim ele é testável sem montar árvore e não
 * depende de quem renderiza. Este hook é só o ciclo de vida.
 */
export function useDragScroll(): void {
  useEffect(() => installDragScroll(), []);
}
